import platinumRankIcon from 'shared/assets/ranking/platinum.svg'
import goldRankIcon from 'shared/assets/ranking/gold.svg'
import silverRankIcon from 'shared/assets/ranking/silver.svg'
import bronzeRankIcon from 'shared/assets/ranking/bronze.svg'
import diamondRankIcon from 'shared/assets/ranking/diamond.svg'
import challengerRankIcon from 'shared/assets/ranking/challenger.svg'

const convertTierIcon = (flag) => {
	const score = Number(flag)
	if (!Number.isFinite(score) || score < 1) return null
	if (score < 500) return bronzeRankIcon
	if (score < 1000) return silverRankIcon
	if (score < 1500) return goldRankIcon
	if (score < 2000) return platinumRankIcon
	if (score < 2500) return diamondRankIcon
	return challengerRankIcon
}

export default convertTierIcon
